import { RouteConfig } from 'vue-router';
import { importPage } from '@/utils/import';

export const routes: RouteConfig[] = [
  { path: '/store/table', component: importPage('store/table') },
  { path: '/store/table/:id', component: importPage('store/table') },
  { path: '/store/login', component: importPage('store/login') },

];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/routers/store.ts